import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const historyStack = ref<string[]>([]);

export function useNavigationHistory() {
  const router = useRouter();
  const route = useRoute();

  // Call this on every route change
  function pushCurrentRoute() {
    const currentPath = route.fullPath;
    if (historyStack.value.length === 0 || historyStack.value[historyStack.value.length - 1] !== currentPath) {
      historyStack.value.push(currentPath);
    }
  }

  function getPreviousRoute() {
    if (historyStack.value.length > 1) {
      // Remove current route
      historyStack.value.pop();
      // Return previous
      return historyStack.value[historyStack.value.length - 1];
    }
    return null;
  }

  function resetHistory() {
    historyStack.value = [];
  }

  return {
    pushCurrentRoute,
    getPreviousRoute,
    resetHistory,
    historyStack,
  };
}
